export default function getExportingJobsFeedTypes(): string {
  return `/exporting/lists/feedTypes`;
}
